// @ts-check
// Keeps the boot scrim alive across cart-line morphs until the overlay clears it.

/** Clear a stalled scrim if the overlay module fails before defining the element. */
// Keep this equal to the pre-paint timeout in snippets/custom.globals.liquid.
const SAFETY_TIMEOUT = 8000;

/** @type {number | undefined} */
let safetyTimer;

/** Reveal the scrim, and arm the escape hatch. */
function startBooting() {
  document.documentElement.dataset.customizerBooting = '';
  clearTimeout(safetyTimer);
  safetyTimer = setTimeout(stopBooting, SAFETY_TIMEOUT);
}

/** Take the scrim back down. Safe to call when it was never up. */
function stopBooting() {
  clearTimeout(safetyTimer);
  delete document.documentElement.dataset.customizerBooting;
}

document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;
  // Modified and non-primary clicks open the link elsewhere (new tab or window) and leave THIS
  // document sitting where it is, with nothing to clear the scrim but the safety timeout.
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
    return;

  const target = /** @type {Element | null} */ (event.target);
  if (!target?.closest?.('[data-customizer-boot]')) return;

  startBooting();
});

// Back-navigation restores this page from the bfcache with its DOM exactly as it was left - scrim
// included - so the shopper would return from the product page to a permanently blurred cart.
window.addEventListener('pageshow', (event) => {
  if (event.persisted) stopBooting();
});
